<template>
  <div class="timelineTile" id="timeline">
    
      <div id="quests-container">
        <div id="quests-title-bar">
          <div id="quests-logo-container">
            <img
              id="quests-title"
              src="../assets/quests-logo.svg"
            />
          </div>
        </div>
        Switch category (Main or Side) for more quests or click one of them for more details.
        <div id="choice-bar">          
            <div
              @click="main_quest($event)"
              class="choice-left choice-button"
              id="main"
              v-bind:class="{choice_selected : isMain}"
            >MAIN</div>
            <div
              @click="main_quest($event)"
              class="choice-button"
              id="side"
              v-bind:class="{choice_selected : !isMain}"
            >SIDE</div>
          
        </div>

        <div v-if="isMain">
          <template v-for="elem in main_quests">
            <div class="quest-padder" v-bind:key="elem.id">
              <div class="quest" :id="elem.id" @click="open_quest($event)">
                <div class="quest-title">
                  <img :src="require('../assets/quests/'+ elem.icon)" class="quest-icon" />
                  <div class="quest-title-text">{{elem.title}}</div>
                </div>
                <div class="second-row">
                  <div class="quest-date">{{elem.date}}</div>
                  <div v-if="elem.score!=null" class="quest-score">{{elem.score}}</div>
                </div>
              </div>
              <div v-if="open === elem.id" class="quest-info"><p v-html="elem.info"></p></div>
              </div>
          </template>
        </div>

        <div v-if="!isMain">
          <template v-for="elem in side_quests">
            <div class="quest-padder" v-bind:key="elem.id">
              <div class="quest" :id="elem.id" @click="open_quest($event)">
                <div class="quest-title">
                  <img :src="require('../assets/quests/'+ elem.icon)" class="quest-icon" />
                  <div class="quest-title-text">{{elem.title}}</div>
                </div>
                <div class="second-row">
                  <div class="quest-date">{{elem.date}}</div>
                  <div class="quest-score">{{elem.score}}</div>
                </div>
              </div>
              <div v-if="open === elem.id" class="quest-info"><p v-html="elem.info"></p>
              </div>
            </div>
          </template>
        </div>
      </div>
    
  </div>
</template>

<script>
import side_quests from "../static/side_quests.js";
import main_quests from "../static/main_quests.js";
export default {
  data() {
    return {
      open: false,
      isMain: true,
      side_quests: side_quests,
      main_quests: main_quests,
    };
  },
  methods: {
    open_quest: function (event) {
      if (this.open === event.currentTarget.id) {
        this.open = false;
      } else {
        this.open = event.currentTarget.id;
      }
    },
    main_quest: function (event) {
      if (event.currentTarget.id === "main") {
        this.isMain = true;
      } else {
        this.isMain = false;
      }
    },
  },
};
</script>

<style>

@font-face {
  font-family: "quest";
  src: url("../assets/fonts/dum3wide.ttf") format("truetype");
}
.timelineTile {
  min-height: 100vh;
  background-color: #e9c46a;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: fit-content;
  overflow: hidden;
  width: 100vw;
  color: white;
  text-align: center;
}

#quests-container {
  width: 800px;
  padding-bottom: 2px;
  display: inline-block;
  height: fit-content;
  background: rgba(0, 123, 148, 0.7);
  border: rgba(0, 123, 148, 1) 2px solid;
  position: relative;  
  margin-top: 50px;
}

#quests-title-bar {
  position: relative;
  height: 50px;
}
#quests-logo-container {
  height: fit-content;
  position: absolute;
  bottom: 0px;
  left: 50%;
}
#quests-title {
  width: 350px;
  position: relative;
  left: -50%;
  display: inline-block;
}
.quest-padder {
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  align-content: center;
  text-align: center;
}
.quest {
  border-radius: 10px;
  color: white;
  padding: 5px;
  position: relative;
  background-image: url("../assets/quest-background.png");
  text-align: left;
  box-shadow: 0 0 0 1px #774936, 0 0 0 2px #bc6c25, 0 0 0 3px #774936;
  display: flex;
  cursor: pointer;
}
.quest-title {
  width: 50%;
  position: relative;
  font-family: "quest";
  background: linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5));
  padding: 5px;
  font-size: 25px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #774936, 0 0 0 2px #bc6c25, 0 0 0 3px #774936;
}

.quest-icon {
  display: inline-block;
  vertical-align: middle;
  padding-right: 10px;
  height: 30px;
}

.quest-title-text {
  width: 80%;
  vertical-align: middle;
  display: inline-block;
}

.quest-date {
  font-family: "quest";
  font-size: 20px;
  background: linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5));
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  width: fit-content;
  position: absolute;
  left: 530px;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: 0 0 0 1px #774936, 0 0 0 2px #bc6c25, 0 0 0 3px #774936;
}
.quest-score {
  font-family: "quest";
  font-size: 20px;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5));
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 0 0 1px #774936, 0 0 0 2px #bc6c25, 0 0 0 3px #774936;
}

.quest-info {
  font-family: "quest";
  color: white;
  display: inline-block;
  text-align: left;
  background-color: rgb(56, 50, 50);
  padding: 10px;
  width: 95%;
  font-size: 20px;
  border-radius: 0 0 10px 10px;
}
.choice-left {
  margin-right: 10px;
}

.choice-button {
  display: inline-block;
  width: fit-content;
  margin-top: 5px;
  font-family: "quest";
  width: 100px;
  cursor: pointer;
  font-size: 25px;
  color: white;
  display: inline-block;
  padding: 10px 10px 5px 10px;
  background: linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)),url("../assets/quest-background.png");
  border-radius: 10px 10px 0px 0px;
  box-shadow: 0 0 0 1px rgba(0, 123, 148, 0.8), 0 0 0 3px rgba(0, 123, 148, 1);
}

.choice_selected {
  background: url("../assets/quest-background.png");
  
  
}
.quest-info a{
  animation: blinker 1s linear infinite;
  color: #e9c46a;
  text-decoration: none;

}
.quest-info a:visited{
  color: #e9c46a;
  text-decoration: none;
}

@keyframes blinker {  
  50% { opacity: 0; }
}

@media (min-width: 320px) and (max-width: 850px) {
  #quests-container {
    width: 95vw;
    height: fit-content;
  }
  .quest {
    display: block;
    position: relative;
    height: fit-content;
  }

  .quest-title {
    width: auto;
  }
  .quest-date {
    position: static;
    transform: none;
  }
  .quest-score {
    position: absolute;
    bottom: 5px;
    right: 5px;
    top: initial;
    transform: none;
  }
  .second-row {
    padding-top: 10px;
  }

  .quest-info {
    width: 90%;
  }
}
</style>